<template>
  <div>
    <v-container fluid>
      <!-- <v-skeleton-loader
        :loading="!flagNav"
        transition="scale-transition"
        max-height="64"
        type="table-heading">
        <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">
            {{ $t("ReportFeedback") }}
          </v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader> -->
      <h2 class="heading-text">Feedback Report Management</h2>
      <div class="mt-2 mb-4"><hr /></div>
      
      <!-- Main Filter Row -->
      <v-card class="card2 pa-2">
        <div class="d-flex align-center gap-2 pa-2" style="margin-top: -12px;">
          <img src="@/assets/material-symbols_arrow-range-rounded.svg" alt="img" width="20" height="20">
          <p class="card-title">{{ $t('dateRange') }}</p>
        </div>
        <v-row class="reportfeedback-filter-row pa-2">
          <v-col cols="12" md="7">
            <v-row class="align-center">
              <v-col cols="12" sm="12" md="5">
                  <div class="mb-1 d-flex align-center" style="gap: 2px">
                    <label for="Start Date" class="text-sm font-medium text-gray-700">
                      Start Date
                    </label>
                    <v-tooltip location="top" max-width="230px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/intent group toolip.svg"
                          alt="info"
                          width="18"
                          height="18"
                          style="cursor: pointer; margin-left: 4px;"
                        />
                      </template>
                      <span>Select start date for searching.</span>
                    </v-tooltip>
                  </div>
  
                  <div class="date-field-wrapper">
                    <v-menu v-model="startDateFlag" :close-on-content-click="false" transition="scale-transition" location="bottom" min-width="auto">
                      <template #activator="{ props }">
                        <v-text-field
                          id="startdate-field-reportfeedback"
                          v-model="startDate"
                          readonly
                          variant="none"
                          v-bind="props"
                          density="compact"
                          clearable
                          color="grey"
                          class="date-style"
                        >
                          <template #prepend-inner>
                            <img src="@/assets/lets-icons_date-range-duotone.svg" alt="img" width="20" height="20" style="margin-left: 6px;" />
                          </template>
                        </v-text-field>
                      </template>
                      <v-date-picker id="startdate-datapicker-reportfeedback"
                        v-model="startDate"
                        :max="endDate != null ? endDate : null"
                        color="red"
                        @update:model-value="val => { startDate = formatDate(val); startDateFlag = false; }"
                      >
                      </v-date-picker>
                    </v-menu>
                  </div>
              </v-col>

              <v-col cols="12" sm="12" md="1" class="mt-8 reportfeedback-separator-col">
                <span class="date-range-separator">–</span>
              </v-col>

              <v-col cols="12" sm="12" md="5">
                <div class="mb-1 d-flex align-center" style="gap: 2px">
                  <label for="End Date" class="text-sm font-medium text-gray-700">
                    End Date
                  </label>
                  <v-tooltip location="top" max-width="230px">
                    <template v-slot:activator="{ props }">
                      <img
                        v-bind="props"
                        src="@/assets/intent group toolip.svg"
                        alt="info"
                        width="18"
                        height="18"
                        style="cursor: pointer; margin-left: 4px;"
                      />
                    </template>
                    <span>Select end date for searching.</span>
                  </v-tooltip>
                </div>
                <div class="date-field-wrapper">
                  <v-menu v-model="endDateFlag" :close-on-content-click="false" transition="scale-transition" location="bottom" min-width="auto">
                    <template #activator="{ props }">
                      <v-text-field
                        id="enddate-field-reportfeedback"
                        v-model="endDate"
                        readonly
                        variant="none"
                        v-bind="props"
                        density="compact"
                        color="grey"
                        clearable
                        class="date-style"
                      >
                        <template #prepend-inner>
                          <img src="@/assets/lets-icons_date-range-duotone.svg" alt="img" width="20" height="20" style="margin-left: 6px;" />
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker
                      id="enddate-datapicker-reportfeedback"
                      v-model="endDate"
                      :min="startDate != null ? startDate : null"
                      color="red"
                      @update:model-value="
                        (val) => {
                          endDate = formatDate(val);
                          endDateFlag = false;
                        }
                      "></v-date-picker>
                  </v-menu>
                </div>
              </v-col>

              <v-col cols="12" sm="12" md="1" class="reportfeedback-search-col">
                <div class="mt-6 reportfeedback-search-wrapper">
                  <button type="button" @click="Search" class="search-btn">
                    <img src="@/assets/search.svg" alt="img" width="18" height="18" style="margin-top: 6px;">
                  </button>
                </div>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" md="5">
            <v-row class="align-center divider-export-download">
              <v-col cols="12" sm="12" md="1"></v-col>
              <v-col cols="12" sm="12" md="4" class="reportfeedback-divider-col">
                <div class="action-divider"></div>
              </v-col>

              <v-col cols="12" sm="12" md="7">
                <button
                  type="button"
                  id="button-download-reportfeedback"
                  variant="none"
                  @click="ExportReportFeedback()"
                  class="download-btn mt-6"
                >
                  <img src="@/assets/bxs_download.svg" alt="img" width="20" height="20" />
                  <span style="color: #ffffff; font-size: 15px;">{{ $t('DownloadReport') }}</span>
                </button>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>

      <!-- Charts Section -->
      <v-card class="card2 pa-2">
          <div class="d-flex align-center flex-start gap-2">
            <img src="@/assets/bar-chart-2-fill.svg" alt="img" width="20" height="20" class="mr-2" />
            <span class="card-title">Feedback Analytics</span>
          </div>
          <v-row class="d-flex align-center pa-2">
            <v-col cols="12" sm="12" md="6">
              <v-card class="reportdata-feedback-chart-card">
                <v-card-title class="d-flex align-center gap-2">
                  <span class="card-title">Like/Dislike Distribution</span>
                  <v-tooltip location="top" max-width="270px">
                    <template v-slot:activator="{ props }">
                      <img
                        v-bind="props"
                        src="@/assets/intent group toolip.svg"
                        alt="info"
                        width="18"
                        height="18"
                        style="cursor: pointer; margin-left: 4px;"
                      />
                    </template>
                    <span>Display the proportion of like and dislike user feedback for the selected period.</span>
                  </v-tooltip>
                </v-card-title>
                <v-card-text class="pa-2">
                  <highcharts :options="chartPie"></highcharts>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-card class="reportdata-feedback-chart-card">
                <v-card-title class="d-flex align-center gap-2">
                  <span class="card-title">Feedback by Model</span>
                  <v-tooltip location="top" max-width="300px">
                    <template v-slot:activator="{ props }">
                      <img
                        v-bind="props"
                        src="@/assets/intent group toolip.svg"
                        alt="info"
                        width="18"
                        height="18"
                        style="cursor: pointer; margin-left: 4px;"
                      />
                    </template>
                    <span>Show user feedback categorized by each model to help analyze performance differences.</span>
                  </v-tooltip>
                </v-card-title>
                <v-card-text class="pa-2">
                  <highcharts :options="chartColumn"></highcharts>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
      </v-card>

      <!-- Data Table Section -->
      <v-card class="reportdata-card-table">
        <v-card-title class="d-flex align-center justify-space-between pa-4">
          <div class="d-flex align-center">
            <span class="card-title"> Report Feedback Table </span>
          </div>
          <div class="d-flex align-center justify-start" style="gap: 12px;">
            <span class="card-title">Show All Text</span>
            <v-switch
              class="memory-switch"
              v-model="CheckboxShowAllText"
              density="compact"
              hide-details>
            </v-switch>
          </div>
        </v-card-title>

        <div class="reportdata-table-container">
          <v-data-table-server
            v-model:options="options"
            :headers="headers"
            :items="dataTableFeedback"
            :items-per-page="itemsPerPage"
            :items-length="searchTotalTable"
            :footer-props="{
              'items-per-page-options': [5, 10, 25, 50, 100],
            }"
            class="pa-4"
            density="comfortable"
            hover>
            <template #no-data>
              <div style="text-align: center;">
                <span style="color: #646464; font-weight: 400;">No Data Available</span>
              </div>
            </template>

            <template v-slot:bottom>
              <div
                class="d-flex justify-space-between align-center px-4 py-2"
                style="width: 100%"
              >
                <div>Total results {{ searchTotalTable }}</div>

                <v-data-table-footer
                  :items="[
                    { text: '10', value: 10 },
                    { text: '25', value: 25 },
                    { text: '50', value: 50 },
                    { text: '100', value: 100 },
                    { text: 'All', value: -1 },
                  ]"
                  :page="options.page"
                  :length="Math.ceil(searchTotalTable / itemsPerPage)"
                />
              </div>
            </template>

            <template #item="{ item }">
              <tr class="reportdata-table-row">
                <td class="text-left">
                  {{ item.no }}
                </td>
                <td class="text-left">
                  <div class="reportdata-feedback-text-container">
                    <span class="reportdata-text-standard">
                      {{ item.text }}
                    </span>
                  </div>
                </td>
                <td class="text-left">
                  <div class="reportdata-feedback-answer-container">
                    <div
                      class="reportdata-feedback-answer-content"
                      :class="{ expanded: item.show }">
                      <span
                        class="reportdata-text-standard"
                        v-html="substringLong(item.replymsg)"></span>
                    </div>
                    <v-btn
                      icon
                      size="small"
                      variant="text"
                      @click="item.show = !item.show"
                      class="reportdata-feedback-toggle-btn">
                      <v-icon size="20">
                        {{
                          item.show ? "mdi-chevron-up" : "mdi-chevron-down"
                        }}
                      </v-icon>
                    </v-btn>
                  </div>
                </td>
                <td class="text-center reportdata-score-cell">
                  <div class="like-dislike-chip-container">
                    <v-chip
                    class="like-dislike-chip"
                    size="small"
                    variant="flat"
                    :color="item.scores === 1 ? '#2ABF56' : '#C30000'"
                    >
                      <v-img
                        :src="item.scores === 1 ? likeIcon : dislikeIcon"
                        width="16"
                        height="16"
                        class="mr-1"
                        alt="icon"
                      />
                      {{ getScoreLabel(item.scores) }}
                    </v-chip>
                  </div>
                </td>
                <td class="text-center">
                  <div class="reportdata-feedback-text-container">
                    <span class="reportdata-text-standard">
                      {{ item.comments }}
                    </span>
                  </div>
                </td>
              </tr>
            </template>
          </v-data-table-server>
        </div>
      </v-card>
    </v-container>

    <v-overlay :model-value="loading" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>

    <v-dialog
      v-model="showDateRequire"
      max-width="460"
      persistent
      location="top"
      content-class="required-date-dialog-content"
    >
      <v-card class="required-name-dialog">
        <div class="required-name-header">
          <h3 class="required-name-title">Action Needed !</h3>
          <button type="button" @click="showDateRequire = false" class="close-btn">
            <img src="@/assets/codex_cross.svg" alt="close" width="24" height="24" style="margin-left: 12px;" />
          </button>
        </div>
        <div class="required-body">
          <p class="required-name-message">{{ dateRequireMessage }}</p>
        </div>
        <div>
          <hr style="border: none; border-top: 1px solid #c9c9c9;" />
        </div>
        <div class="required-footer">
          <v-btn class="ok-required-btn" @click="showDateRequire = false" id="button-requireddate-ok">OK</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";
import dateUtils from "../plugins/date-utils";
import moment from "moment";
import likeIcon from "@/assets/iconamoon_like.svg";
import dislikeIcon from "@/assets/iconamoon_dislike.svg";
export default {
  name: "ReportFeedback",
  inject: ["flagNav","FontColorTitle","SubNavbarBackGround"],
  data: () => ({
    // isChartOptions: false,
    showDateRequire: false,
    dateRequireMessage: "",
    isInitialized: false,
    today: null,
    startDateFlag: false,
    endDateFlag: false,
    startDate: null,
    endDate: null,
    isSearch: false,
    isFirst: true,
    loading: false,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    dataTableFeedback: [],
    itemsPerPage: 10,
    totalTable: 0,
    searchTotalTable: 0,
    sortBy: [],
    sortDesc: [],
    // loadingCard: false,
    chartPie: {
      chart: {
        type: "pie",
        backgroundColor: "transparent",
        events: {
          render: function () {
            const series = this.series && this.series[0];
            const points = series && series.points ? series.points : [];
            const totalDisplay = points.reduce((sum, p) => {
              const displayY =
                typeof p?.options?.displayY === "number"
                  ? p.options.displayY
                  : typeof p?.displayY === "number"
                    ? p.displayY
                    : typeof p?.y === "number"
                      ? p.y
                      : 0;
              return sum + displayY;
            }, 0);

            if (totalDisplay > 0) {
              if (this.__noDataTextLine1) {
                this.__noDataTextLine1.destroy();
                this.__noDataTextLine1 = null;
              }
              if (this.__noDataTextLine2) {
                this.__noDataTextLine2.destroy();
                this.__noDataTextLine2 = null;
              }
              return;
            }

            if (typeof this.hideNoData === "function") {
              this.hideNoData();
            }

            const centerX = this.plotLeft + this.plotWidth / 2;
            const centerY = this.plotTop + this.plotHeight / 2;

            const line1Y = centerY - 6;
            const line2Y = centerY + 12;

            if (!this.__noDataTextLine1) {
              this.__noDataTextLine1 = this.renderer
                .text("No Data", centerX, line1Y)
                .css({
                  color: "#171717",
                  fontSize: "12px",
                  fontWeight: "600",
                })
                .attr({ align: "center" })
                .add();
            } else {
              this.__noDataTextLine1.attr({ x: centerX, y: line1Y });
            }

            if (!this.__noDataTextLine2) {
              this.__noDataTextLine2 = this.renderer
                .text("Available", centerX, line2Y)
                .css({
                  color: "#171717",
                  fontSize: "12px",
                  fontWeight: "600",
                })
                .attr({ align: "center" })
                .add();
            } else {
              this.__noDataTextLine2.attr({ x: centerX, y: line2Y });
            }
          },
        },
      },
      title: {
        text: "",
        align: "center",
        verticalAlign: "middle",
        floating: true,
        y: -10,
        style: {
          fontSize: "26px",
          fontWeight: "700",
          color: "#171717",
        },
      },
      subtitle: {
        text: "",
        align: "center",
        verticalAlign: "middle",
        floating: true,
        y: 18,
        style: {
          fontSize: "14px",
          fontWeight: "500",
          color: "#171717",
        },
      },
      tooltip: {
        useHTML: true,
        headerFormat: "<b>{point.name}</b>",
        pointFormat:
          '<span style="color:{point.color}">\u25CF</span> Percentage : <b>{point.displayY}%</b>',
      },
      credits: { enabled: false },
      plotOptions: {
        pie: {
          innerSize: "50%",
          borderWidth: 0,
          allowPointSelect: true,
          cursor: "pointer",
          states: {
            hover: { brightness: 0 },
            inactive: { opacity: 1 },
          },
          point: {
            events: {
              mouseOver: function () {
                const points = this.series?.points || [];
                const totalDisplay = points.reduce((sum, p) => {
                  const displayY =
                    typeof p?.options?.displayY === "number"
                      ? p.options.displayY
                      : typeof p?.displayY === "number"
                        ? p.displayY
                        : typeof p?.y === "number"
                          ? p.y
                          : 0;
                  return sum + displayY;
                }, 0);
                if (totalDisplay <= 0) return;

                const hoveredName = (this.name || "").toString().toLowerCase();
                const likePoint = points.find(
                  (p) => (p?.name || "").toString().toLowerCase() === "like"
                );
                const dislikePoint = points.find(
                  (p) => (p?.name || "").toString().toLowerCase() === "dislike"
                );

                if (hoveredName === "like") {
                  if (likePoint) likePoint.update({ color: "#C32E0E" }, false);
                  if (dislikePoint)
                    dislikePoint.update({ color: "#CCCCCC" }, false);
                } else if (hoveredName === "dislike") {
                  if (likePoint) likePoint.update({ color: "#CCCCCC" }, false);
                  if (dislikePoint)
                    dislikePoint.update({ color: "#FFA292" }, false);
                }

                this.series?.chart?.redraw();
              },
              mouseOut: function () {
                const points = this.series?.points || [];
                const totalDisplay = points.reduce((sum, p) => {
                  const displayY =
                    typeof p?.options?.displayY === "number"
                      ? p.options.displayY
                      : typeof p?.displayY === "number"
                        ? p.displayY
                        : typeof p?.y === "number"
                          ? p.y
                          : 0;
                  return sum + displayY;
                }, 0);
                if (totalDisplay <= 0) return;

                const likePoint = points.find(
                  (p) => (p?.name || "").toString().toLowerCase() === "like"
                );
                const dislikePoint = points.find(
                  (p) => (p?.name || "").toString().toLowerCase() === "dislike"
                );

                if (likePoint) likePoint.update({ color: "#C32E0E" }, false);
                if (dislikePoint)
                  dislikePoint.update({ color: "#FFA292" }, false);

                this.series?.chart?.redraw();
              },
            },
          },
          dataLabels: { enabled: false },
          showInLegend: true,
        },
      },
      legend: {
        enabled: true,
        useHTML: true,
        align: "center",
        verticalAlign: "bottom",
        layout: "horizontal",
        symbolWidth: 0,
        symbolHeight: 0,
        symbolRadius: 0,
        labelFormatter: function () {
          const value =
            typeof this?.options?.displayY === "number"
              ? this.options.displayY
              : typeof this?.displayY === "number"
                ? this.displayY
                : this.y;
          return `
              <div class="d-flex align-center justify-space-between" style="gap: 16px;">
                  <div class="feedback-pie-legend-pill">
                    <span class="feedback-pie-legend-dot" style="background:${this.color}"></span>
                    <span class="feedback-pie-legend-name">${this.name}</span>
                  </div>
                <div class="feedback-pie-legend-value">${value}%</div>
              </div>
          `;
        },
      },
      series: [
        {
          name: "Percentage",
          colorByPoint: true,
          data: [
            { name: "Like", y: 50, color: "#C32E0E" },
            { name: "Dislike", y: 50, color: "#FFA292" },
          ],
        },
      ],
    },
    chartColumn: {
      chart: {
        type: "column",
        events: {
          render: function () {
            const seriesList = Array.isArray(this.series) ? this.series : [];
            const points = seriesList.flatMap((s) =>
              Array.isArray(s?.points) ? s.points : []
            );
            const total = points.reduce(
              (sum, p) => sum + (typeof p?.y === "number" ? p.y : 0),
              0
            );

            if (total > 0) {
              if (this.__noDataText) {
                this.__noDataText.destroy();
                this.__noDataText = null;
              }
              return;
            }

            if (typeof this.hideNoData === "function") {
              this.hideNoData();
            }

            const centerX = this.plotLeft + this.plotWidth / 2;
            const centerY = this.plotTop + this.plotHeight / 2;

            if (!this.__noDataText) {
              this.__noDataText = this.renderer
                .text("No Data Available", centerX, centerY)
                .css({
                  color: "#171717",
                  fontSize: "14px",
                  fontWeight: "600",
                })
                .attr({ align: "center" })
                .add();
            } else {
              this.__noDataText.attr({ x: centerX, y: centerY });
            }
          },
        },
      },
      title: { text: "" },
      credits: { enabled: false },
      legend: { enabled: false },
      plotOptions: {
        column: {
          states: {
            hover: { brightness: 0 },
            inactive: { opacity: 1 },
          },
          point: {
            events: {
              mouseOver: function () {
                const chart = this.series?.chart;
                if (!chart || !Array.isArray(chart.series)) return;

                const hoveredSeriesName = (this.series?.name || "")
                  .toString()
                  .toLowerCase();
                const likeSeries = chart.series.find(
                  (s) => (s?.name || "").toString().toLowerCase() === "like"
                );
                const dislikeSeries = chart.series.find(
                  (s) =>
                    (s?.name || "").toString().toLowerCase() === "dislike"
                );

                if (hoveredSeriesName === "like") {
                  if (likeSeries) likeSeries.update({ color: "#C32E0E" }, false);
                  if (dislikeSeries)
                    dislikeSeries.update({ color: "#CCCCCC" }, false);
                } else if (hoveredSeriesName === "dislike") {
                  if (likeSeries) likeSeries.update({ color: "#CCCCCC" }, false);
                  if (dislikeSeries)
                    dislikeSeries.update({ color: "#FFA292" }, false);
                }

                chart.redraw();
              },
              mouseOut: function () {
                const chart = this.series?.chart;
                if (!chart || !Array.isArray(chart.series)) return;

                const likeSeries = chart.series.find(
                  (s) => (s?.name || "").toString().toLowerCase() === "like"
                );
                const dislikeSeries = chart.series.find(
                  (s) =>
                    (s?.name || "").toString().toLowerCase() === "dislike"
                );

                if (likeSeries) likeSeries.update({ color: "#C32E0E" }, false);
                if (dislikeSeries)
                  dislikeSeries.update({ color: "#FFA292" }, false);

                chart.redraw();
              },
            },
          },
        },
      },
      //แต่ละ model
      xAxis: { categories: [], crosshair: true },
      yAxis: { min: 0, title: { text: "Number of feedback" } },
      tooltip: { valueSuffix: "", footerFormat: "</table>" },
      series: [
        { name: "Like", data: [], color: "#C32E0E", },
        { name: "Dislike", data: [], color: "#FFA292",},
      ],
    },
    ShowAllText: false,
    CheckboxShowAllText: false,
    likeIcon,
    dislikeIcon,
  }),
  components: {
    highcharts: Chart,
  },
  watch: {
    options: {
      handler() {
        if (!this.isInitialized) return;
        this.GetTableReportFeedback();
      },
      deep: true,
    },
    CheckboxShowAllText(newVal) {
      let self = this;
      if (newVal) {
        self.ShowAll();
      } else {
        self.CloseShowAll();
      }
    },
  },
  methods: {
    hasValidDateRange() {
      const start = (this.startDate ?? "").toString().trim();
      const end = (this.endDate ?? "").toString().trim();
      return start.length > 0 && end.length > 0;
    },
    openDateRequireDialog(message) {
      this.dateRequireMessage = message;
      this.showDateRequire = true;
    },
    formatDate(dateInput) {
      if (!dateInput) {
        return "";
      }
      if (
        typeof dateInput === "string" &&
        /^\d{4}-\d{2}-\d{2}$/.test(dateInput)
      ) {
        return dateInput;
      }

      const d = new Date(dateInput);
      if (isNaN(d.getTime())) {
        return dateInput.toString().substr(0, 10);
      }

      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      const date = `${year}-${month}-${day}`;
      return date;
    },
    Search() {
      let self = this;
      self.loading = true;
      self.isSearch = true;
      self.isFirst = true;
      self.GetTableReportFeedback();
    },
    getScoreLabel(scores) {
      return scores === 1 ? "Like" : "Dislike";
    },
    GetTableReportFeedback() {
      let self = this;
      self.loading = true;
      if (self.hasValidDateRange()) {
        const { page, itemsPerPage } = self.options;
        let temp = {
          page: self.isSearch ? 1 : page,
          perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
          StartDate: self.startDate,
          EndDate: self.endDate,
        };
        self.$call.GetTableReportFeedback(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              if (dataResponse.data.total > 0) {
                self.searchTotalTable = dataResponse.data.total;
                self.dataTableFeedback = dataResponse.data.data;
                self.totalTable = self.isFirst
                  ? dataResponse.data.total
                  : self.totalTable;
                self.options.page = temp.page;
                self.chartPie.series[0].data = self.NormalizeChartPieData(
                  dataResponse.data.pie
                );
                self.ApplyChartPieBaseColors();
                self.UpdateChartPieCenter();
                self.chartColumn.series = dataResponse.data.column.information;
                self.ApplyChartColumnColors();
                self.chartColumn.xAxis.categories =
                  dataResponse.data.column.model;
              } else {
                self.dataTableFeedback = [];
                self.chartPie.series[0].data = self.NormalizeChartPieData(null);
                self.ApplyChartPieBaseColors();
                self.UpdateChartPieCenter();
                self.chartColumn.series = [];
                self.ApplyChartColumnColors();
                self.chartColumn.xAxis.categories = [];
                self.totalTable = 0;
                self.searchTotalTable = 0;
              }
            } else {
              self.dataTableFeedback = [];
              self.searchTotalTable = 0;
              self.totalTable = 0;
            }
            self.loading = false;
            self.isSearch = false;
            self.isFirst = false;
            self.dataTableFeedback.forEach((element) => {
              element.show = self.ShowAllText;
            });
          },
          (errorResource) => {
            self.loading = false;
            self.isSearch = false;
            console.error(errorResource);
          }
        );
      } else {
        self.openDateRequireDialog(
          "Date range is required. Please select both a start and end date."
        );
        self.loading = false;
        return;
      }
    },
    UpdateChartPieCenter() {
      let self = this;
      const seriesData = self.chartPie?.series?.[0]?.data;
      if (!Array.isArray(seriesData) || seriesData.length === 0) {
        self.chartPie.title.text = "";
        self.chartPie.subtitle.text = "";
        return;
      }

      const totalDisplay = seriesData.reduce((sum, p) => {
        const displayY =
          typeof p?.displayY === "number"
            ? p.displayY
            : typeof p?.y === "number"
              ? p.y
              : 0;
        return sum + displayY;
      }, 0);

      if (totalDisplay <= 0) {
        self.chartPie.title.text = "";
        self.chartPie.subtitle.text = "";
        return;
      }

      const likePoint = seriesData.find(
        (p) => (p?.name || "").toString().toLowerCase() === "like"
      );
      const likePercent =
        typeof likePoint?.displayY === "number" ? likePoint.displayY : likePoint?.y;

      if (likePercent === null || likePercent === undefined || isNaN(likePercent)) {
        self.chartPie.title.text = "";
        self.chartPie.subtitle.text = "";
        return;
      }

      self.chartPie.title.text = `${Math.round(Number(likePercent))}%`;
      self.chartPie.subtitle.text = "Likes";
    },
    ApplyChartPieBaseColors() {
      let self = this;
      const seriesData = self.chartPie?.series?.[0]?.data;
      if (!Array.isArray(seriesData) || seriesData.length === 0) return;

      const totalDisplay = seriesData.reduce((sum, p) => {
        const displayY =
          typeof p?.displayY === "number"
            ? p.displayY
            : typeof p?.y === "number"
              ? p.y
              : 0;
        return sum + displayY;
      }, 0);

      if (totalDisplay <= 0) {
        self.chartPie.series[0].data = seriesData.map((p) => ({
          ...p,
          color: "#CCCCCC",
        }));
        return;
      }

      self.chartPie.series[0].data = seriesData.map((p) => {
        const name = (p?.name || "").toString().toLowerCase();
        if (name === "like") return { ...p, color: "#C32E0E" };
        if (name === "dislike") return { ...p, color: "#FFA292" };
        return p;
      });
    },

    NormalizeChartPieData(pieData) {
      const getPoint = (arr, name) =>
        Array.isArray(arr)
          ? arr.find((p) => (p?.name || "").toString().toLowerCase() === name)
          : null;

      const likeRaw = getPoint(pieData, "like");
      const dislikeRaw = getPoint(pieData, "dislike");

      const likeValue =
        typeof likeRaw?.y === "number" && !isNaN(likeRaw.y) ? likeRaw.y : 0;
      const dislikeValue =
        typeof dislikeRaw?.y === "number" && !isNaN(dislikeRaw.y)
          ? dislikeRaw.y
          : 0;

      const totalDisplay = likeValue + dislikeValue;

      if (totalDisplay <= 0) {
        return [
          { name: "Like", y: 1, displayY: 0, color: "#CCCCCC" },
          { name: "Dislike", y: 1, displayY: 0, color: "#CCCCCC" },
        ];
      }

      return [
        {
          ...(likeRaw || {}),
          name: likeRaw?.name || "Like",
          y: likeValue,
          displayY: likeValue,
        },
        {
          ...(dislikeRaw || {}),
          name: dislikeRaw?.name || "Dislike",
          y: dislikeValue,
          displayY: dislikeValue,
        },
      ];
    },
    ApplyChartColumnColors() {
      let self = this;
      if (!Array.isArray(self.chartColumn?.series)) return;

      self.chartColumn.series = self.chartColumn.series.map((s) => {
        const name = (s?.name || "").toString().toLowerCase();
        if (name === "like") return { ...s, color: "#C32E0E" };
        if (name === "dislike") return { ...s, color: "#FFA292" };
        return s;
      });
    },
    ExportReportFeedback() {
      let self = this;
      self.loading = true;
      if (self.hasValidDateRange()) {
        let temp = {
          StartDate: self.startDate,
          EndDate: self.endDate,
        };
        self.$call.ExportReportFeedback(
          temp,
          (dataResponse) => {
            if (dataResponse) {
              let fileURL = window.URL.createObjectURL(
                new Blob([dataResponse])
              );
              let fileLink = document.createElement("a");

              fileLink.href = fileURL;

              let fileNameshow = `ReportFeedback__${
                self.convertDateToString2(self.startDate, "") +
                "-" +
                self.convertDateToString2(self.endDate, "")
              }.xlsx`;
              fileLink.setAttribute("download", fileNameshow);
              document.body.appendChild(fileLink);

              fileLink.click();
            }
            self.loading = false;
          },
          (errorResource) => {
            self.loading = false;
            console.error(errorResource);
          }
        );
      } else {
        self.openDateRequireDialog("Please fill the required fields.");
        self.loading = false;
        return;
      }
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
    convertDateToString(date, seperator = "/") {
      return dateUtils.getStringWithTimeFromDate(
        moment(date).toDate(),
        seperator
      );
    },
    convertDateToString2(date, seperator = "-") {
      return dateUtils.getStringFromDatePickFormatDatePick2(
        moment(date).toDate(),
        seperator
      );
    },
    substringLong(value) {
      if (value == null) {
        return "-";
      }
      if (value.length > 4000) {
        return value.substring(0, 3999) + ".....";
      }
      return value;
    },
    ShowAll() {
      let self = this;
      self.ShowAllText = !self.ShowAllText;
      self.dataTableFeedback.forEach((element) => {
        element.show = self.ShowAllText;
      });
    },
    CloseShowAll() {
      let self = this;
      self.ShowAllText = !self.ShowAllText;
      self.dataTableFeedback.forEach((element) => {
        element.show = self.ShowAllText;
      });
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
  },
  computed: {
    headers() {
      return [
        { title: this.$t("no"), value: "no", align: "left", sortable: false },
        {
          title: this.$t("Questions"),
          value: "text",
          align: "left",
          sortable: false,
        },
        {
          title: this.$t("Answers"),
          value: "replymsg",
          align: "left",
          sortable: false,
          width: "420px",
        },
        {
          title: this.$t("LikeDislike"),
          width: "120px",
          value: "scores",
          align: "center",
          sortable: false,
        },
        {
          title: this.$t("Comments"),
          value: "comments",
          align: "center",
          sortable: false,
        },
      ];
    },
  },
  mounted() {
    let self = this;
    // self.loadingCard = true;
    self.GetDate();
    var date = new Date();
    self.endDate = self.convertDateToString2(date);
    self.startDate = self.convertDateToString2(date);
    self.GetTableReportFeedback();
    self.isInitialized = true;
  },
};
</script>
<style scoped>
  .heading-text {
  color: #171717;
  font-weight: 600;
}
  hr {
  border: none;
  border-top: 1px solid #c9c9c9;
}
.card2 {
  border: 1px solid #DCDCDC !important;
  border-radius: 10px !important;
  box-shadow: none;
  padding: 10px;
}

.reportfeedback-filter-row {
  margin-top: -20px;
}
.date-style {
  border: 1px solid #c9c9c9;
  border-radius: 10px;
  height: 40px;
}
.date-divider-style {
  display: flex;
  justify-content: flex-start;
}
.date-range-separator {
  color: #c9c9c9;
  font-weight: 600;
  font-size: 22px;
}
.date-field-wrapper {
  width: 100%;
}
.reportfeedback-separator-col {
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (max-width: 959px) {
  .date-field-wrapper {
    width: 100%;
  }

  .reportfeedback-separator-col {
    display: none;
  }

  .reportfeedback-search-wrapper {
    display: flex;
    justify-content: flex-start;
  }

  .reportfeedback-divider-col {
    display: none;
  }

  .search-divider {
    margin-left: 0;
    justify-content: flex-start;
  }

  .download-btn {
    width: 100%;
  }
}

@media (min-width: 960px) and (max-width: 1024px) {
  .divider-export-download {
    display: flex;
    justify-content: space-between !important;
    align-items: center;
    margin-left: 16px;
  }
  .reportfeedback-divider-col {
    display: none;
  }

  .download-btn {
    width: 100%;
    margin-top: 22px !important;
  }

  .action-divider {
    margin-top: 0;
    height: 40px;
  }
}
:deep(.feedback-pie-legend-pill) {
  display: flex;
  align-items: center !important;
  justify-content: center !important;
  gap: 10px;
  padding: 8px 12px;
  border-radius: 6px;
  background: #ffffff !important;
  box-shadow: 0px 4px 22px 0px rgba(23, 23, 23, 0.25) !important;
}
:deep(.feedback-pie-legend-dot) {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  flex-shrink: 0;
}
:deep(.feedback-pie-legend-name) {
  font-weight: 400;
  font-size: 14px;
  border-radius: 10px;
}
:deep(.feedback-pie-legend-value) {
  color: #171717;
  font-weight: 700;
  font-size: 15px;
}
.search-divider {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: 16px;
}
.search-btn {
  background: linear-gradient(100deg, #C32E0E 0%, #F67760 100%) !important;
  height: 32px;
  width: 32px;
  border-radius: 18px;
}
.divider-export-download {
  display: flex;
  justify-content: space-between !important;
  align-items: center;
}
.action-divider {
  width: 2px;
  height: 52px;
  background: rgba(0, 0, 0, 0.12);
  border-radius: 1px;
  margin-top: 20px;
}
.download-btn {
  display: flex;
  background: linear-gradient(100deg, #C32E0E 0%, #F67760 100%) !important;
  border-radius: 10px;
  width: 200px;
  justify-content: center;
  align-items: center;
  padding: 10px;
  gap: 6px;
}
.download-btn:hover{
  background: linear-gradient(100deg, #F36243 0%, #FF8E7A 100%) !important;
}
.card-title {
  color: #171717;
  font-weight: 600;
  font-size: 18px;
}
.required-name-dialog {
  border-radius: 12px !important;
  background: #FFFFFF;
  border: 1px solid #F4D6B8;
}

:deep(.required-date-dialog-content) {
  align-self: flex-start;
  margin-top: 110px;
}
.required-name-dialog :deep(.v-divider) {
  border-color: #F4D6B8 !important;
}

.required-name-dialog .close-btn {
  color: #B45800;
}

.required-name-dialog .close-btn:hover {
  color: #8C3F00;
}
.required-name-header {
  background: linear-gradient(00deg,#FFF8ED, #FFF0DA);
  padding: 10px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.required-name-title {
  font-size: 16px;
  font-weight: 600;
  color: #FFA726;
}
.required-body {
  padding: 16px;
}
.required-name-message {
  font-size: 14px;
  color: #171717;
}
.required-footer {
  display:flex;
  justify-content:flex-end;
  padding: 10px 26px;
}
.ok-required-btn {
  border-radius: 10px;
  font-weight:500;
  font-size:13px;
  color: #ffffff !important;
  width: 104px;
  background: #FFA726;
}
/* v-switch */
.memory-switch :deep(.v-switch__track) {
  background: #a6a6a6 !important; /* off state */
  border: 1px solid #ffffff !important;
  opacity: 1 !important;
  height: 20px !important;
  width: 32px !important;
  border-radius: 22px !important;
}
.memory-switch :deep(.v-switch__thumb) {
  box-shadow: none !important;
  height: 16px !important;
  width: 16px !important;
  margin-left: 4px !important;
  background-color: #FFFFFF !important;
}
/* Active (on) state */
.memory-switch :deep(.v-selection-control--dirty .v-switch__track) {
  background-color: #FFFFFF !important;
  border: 1px solid #C32E0E !important;
  
}
.memory-switch :deep(.v-selection-control--dirty .v-switch__thumb) {
  background-color: #C32E0E !important;
  margin-right: 8px !important;
}
.memory-switch :deep(.v-switch__loader) {
  display: none !important;
}
:deep(.v-data-table-server) {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
:deep(thead) {
  background-color: #FFE4E1 !important;
  padding: 0 8px;
}
.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-left .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 15px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-center .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 15px;
}

:deep(.reportdata-table-row td) {
  vertical-align: top;
}

:deep(.reportdata-score-cell .v-chip) {
  margin-top: 12px;
}
.like-dislike-chip-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.like-dislike-chip {
  width: 80px;
  color: #FFFFFF !important;
  display: flex;
  justify-content: center !important;
  align-items: center;
  gap: 8px;
}
/* Chart Cards */
.reportdata-feedback-chart-card {
  border: 1px solid #C9C9C9 !important;
  border-radius: 12px !important;
  margin-bottom: 1rem;
  box-shadow: none !important;
  overflow: hidden;
}


/* Text Content Containers */
.reportdata-feedback-text-container {
  padding: 8px 0;
  max-width: 100%;
  word-break: break-word;
  overflow-wrap: break-word;
}

.reportdata-feedback-answer-container {
  display: flex;
  align-items: flex-start;
  max-width: 400px;
}

.reportdata-feedback-answer-content {
  flex: 1;
  margin-right: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
  transition: all 0.3s ease;
}

.reportdata-feedback-answer-content.expanded {
  -webkit-line-clamp: unset;
  display: block;
}

.reportdata-feedback-toggle-btn {
  flex-shrink: 0;
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.reportdata-feedback-toggle-btn:hover {
  opacity: 1;
}
</style>
